import React from 'react';
import linkedInLogo from 'src/assets/images/linkedin-logo.svg';
import { Button } from '@material-ui/core';
import { useStyles } from './styles';

export const LinkedInButton: React.FC<any> = (props) => {
  const classes = useStyles();
  return (
    <Button className={classes.root} variant="outlined" {...props}>
      <img src={linkedInLogo} className={classes.img} alt="LinkedIn" />
      <span className={classes.text}>LinkedIn</span>
    </Button>
  );
};
